import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function WhatIsIncludedSection() {
  const mainFeatures = ['Más de 200 páginas de contenido profesional', 'Sistema de organización de clientes', 'Control de vencimientos fiscales', 'Plantillas contables listas para usar', 'Sistema de seguimiento de pagos', 'Organización digital de documentos', 'Checklists para procesos contables'];
  const bonusFeatures = ['Estructura de organización para estudios contables independientes', 'Modelos de registro y seguimiento de clientes', 'Sistema simple para ordenar documentación contable'];
  return <section className="py-20 px-4 bg-[#0B1A2E] border-t border-slate-800" data-id="element-440">
      <div className="max-w-3xl mx-auto" data-id="element-441">
        {/* Intro text */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center text-slate-300 text-base md:text-lg leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-442">
          Este sistema fue diseñado para ayudarte a organizar tu estudio
          contable con herramientas prácticas listas para usar.
        </motion.p>

        {/* Title */}
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-white text-center mb-12" data-id="element-443">
          ¿Qué incluye el sistema?
        </motion.h2>

        {/* Main features */}
        <div className="bg-slate-800/40 border border-slate-700/50 rounded-2xl p-6 md:p-8 mb-8" data-id="element-444">
          <div className="space-y-4" data-id="element-445">
            {mainFeatures.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -15
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.07
          }} className="flex items-start gap-3" data-id="element-446">
                <div className="bg-green-500/20 p-1 rounded-full flex-shrink-0 mt-0.5" data-id="element-447">
                  <CheckIcon className="w-4 h-4 text-green-400" data-id="element-448" />
                </div>
                <span className="text-base md:text-lg text-slate-200" data-id="element-449">
                  {feature}
                </span>
              </motion.div>)}
          </div>
        </div>

        {/* Bonus features */}
        <motion.h3 initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-xl md:text-2xl font-bold text-blue-300 text-center mb-6" data-id="element-450">
          Además recibirás
        </motion.h3>

        <div className="bg-blue-900/20 border border-blue-800/30 rounded-2xl p-6 md:p-8 mb-10" data-id="element-451">
          <div className="space-y-4" data-id="element-452">
            {bonusFeatures.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -15
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.07
          }} className="flex items-start gap-3" data-id="element-453">
                <div className="bg-green-500/20 p-1 rounded-full flex-shrink-0 mt-0.5" data-id="element-454">
                  <CheckIcon className="w-4 h-4 text-green-400" data-id="element-455" />
                </div>
                <span className="text-base md:text-lg text-slate-200" data-id="element-456">
                  {feature}
                </span>
              </motion.div>)}
          </div>
        </div>

        {/* Closing text */}
        <motion.p initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center text-lg md:text-xl text-slate-300 font-medium italic mb-10" data-id="element-457">
          Todo pensado para ayudarte a trabajar con más orden, control y
          eficiencia.
        </motion.p>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-458">
          <CTAButton text="Acceder al sistema ahora" className="py-5 px-10 text-xl" data-id="element-459" />
        </motion.div>
      </div>
    </section>;
}